import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import UnitDetailContainer from '../../../../components/componentsInventoryManagement/_Lot_Tracking_Components/UnitDetail/UnitDetailContainer';


class invManUnitDetailView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <UnitDetailContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default invManUnitDetailView;
